<script setup lang="ts">
  import { useVModel } from '@vueuse/core';
  import { computed, useTemplateRef } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
    defaultValue?: string | number;
    modelValue?: string | number | null;
  }>();

  const emits = defineEmits<{
    (e: 'update:modelValue', payload: string | number): void;
  }>();

  const modelValue = useVModel(props, 'modelValue', emits, {
    defaultValue: props.defaultValue,
    passive: true,
  });

  const textareaEl = useTemplateRef('textareaEl');

  defineExpose({
    textarea: computed(() => textareaEl.value),
  });
</script>

<template>
  <textarea
    ref="textareaEl"
    v-model="modelValue"
    data-slot="textarea"
    :class="
      cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-sm border bg-background dark:bg-input/30 px-3 py-2 text-sm transition-color outline-none focus-visible:ring-[2px] disabled:cursor-not-allowed disabled:opacity-50',
        props.class,
      )
    "
  />
</template>
